import type { AxiosInstance } from 'axios';
import authService from './auth.service';

export type ComplianceState = 'ok' | 'warning' | 'remediation_required';
export type ComplianceReason =
  | ''
  | 'upcoming_workflow_cutoff'
  | 'workflow_version_expired'
  | 'document_expired'
  | 'identity_document_expired'
  | 'tax_form_renewal'
  | 'tax_form_invalid';

export interface ComplianceStatus {
  state: ComplianceState;
  deadline: string | null;
  remediation_case_id: string | null;
  reason: ComplianceReason;
}

class ComplianceStatusService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  async getForClient(clientId: string): Promise<ComplianceStatus> {
    const res = await this.api.get<ComplianceStatus>(
      `/api/v1/clients/${clientId}/compliance-status`,
    );
    return res.data;
  }

  async getMine(): Promise<ComplianceStatus> {
    const id = await authService.getMyId();
    return this.getForClient(id);
  }
}

export default new ComplianceStatusService();
